import React from 'react';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';
import '../styles/DashboardLayout.css'; // Importing CSS

interface DashboardLayoutProps {
  children: React.ReactNode; // Define the `children` prop type
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="dashboard-layout">
      <TopNavbar />
      {/* <div className="dashboard-body"> */}
        <Sidebar />
        <div className="dashboard-content">
          {children}
        </div>
      </div>
    // </div>
  );
};

export default DashboardLayout;
